export default __webpack_public_path__ + "static/media/emoji_food_beverage.5b3fc1f2.svg";